import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    // Category management moved into Configure (2026-08-03 category-UX
    // decision); the old standalone page was never linked from anywhere.
    // Keep the path alive for deep links and redirect it to the section.
    path: '/auctions/:id/catalog/categories',
    name: 'categories',
    redirect: to => ({
      path: `/auctions/${to.params.id as string}/configure`,
      hash: '#section-categories',
    }),
  },
];
